/**
 * Indicates that a user has successfully placed an order
 */
import { CxEvent } from '@spartacus/core';
import { CustomCheckoutModel, CustomCheckoutStepsModel } from './custom-checkout-steps.model';

/**
 * Indicates that a user visited a checkout step page.
 */
export class CustomCheckoutStepsEvent extends CxEvent {
  /** event's type */
  static readonly type = 'CheckoutStepsPageEvent';
  event: string;
  ecommerce: CustomCheckoutStepsModel;
}

/**
 * Indicates that a user change a checkout delivery mode.
 */
export class CustomCheckoutDeliveryModeEvent extends CxEvent {
  /** event's type */
  static readonly type = 'CheckoutDeliveryModeEvent';
  event: string;
  ecommerce: CustomCheckoutStepsModel;
}

/**
 * Indicates that a user change a payment mode.
 */
export class CustomCheckoutPaymentModeEvent extends CxEvent {
  /** event's type */
  static readonly type = 'CheckoutPaymentModeEvent';
  event: string;
  ecommerce: CustomCheckoutStepsModel;
}

/**
 * Indicates that a user has begun checkout flow.
 */
export class CustomCheckoutBeginEvent extends CxEvent {
  /** event's type */
  static readonly type = 'CheckoutBeginEvent';
  event: string;
  ecommerce: CustomCheckoutModel;
}

/**
 * Indicates the user has selected a shipping method during the checkout process.
 * Trigger event on successful form submission
 */
export class CustomCheckoutAddShippingInfoEvent extends CxEvent {
  /** event's type */
  static readonly type = 'CheckoutAddShippingInfoEvent';
  event: string;
  ecommerce: CustomCheckoutModel;
}

/**
 * Indicates the user has selected a shipping method during the checkout process.
 * Trigger event on successful form submission
 */
export class CustomCheckoutAddPaymentInfoEvent extends CxEvent {
  /** event's type */
  static readonly type = 'CheckoutAddPaymentInfoEvent';
  event: string;
  ecommerce: CustomCheckoutModel;
}


